import { render } from "./MyComments.vue?vue&type=template&id=df7a7bb4"
import script from "./MyComments.vue?vue&type=script&lang=js"
export * from "./MyComments.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__